import dayjs from 'dayjs';

type DateValue = string | number | Date;

export const formatCommentTimestamp = (
  createdAt: DateValue,
  referenceDate: DateValue = Date.now(),
) => {
  const timestamp = dayjs(createdAt);
  const reference = dayjs(referenceDate);

  if (!timestamp.isValid()) return '';

  const time = timestamp.format('h:mm A');

  if (timestamp.isSame(reference, 'day')) {
    return `Today, ${time}`;
  }

  if (timestamp.isSame(reference.subtract(1, 'day'), 'day')) {
    return `Yesterday, ${time}`;
  }

  const date = timestamp.format(
    timestamp.year() === reference.year() ? 'MMM D' : 'MMM D, YYYY',
  );

  return `${date}, ${time}`;
};
